import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Icon, IconButton, InputText } from '@lambdacurry/component-library';
import { useFilters } from './Filters.helpers';
import debounce from 'lodash/debounce';
import { Filter } from './Filters.types';

export const FiltersSearchInput = () => {
  const { state, actions } = useFilters();
  const { setFilter } = actions;
  const searchFilter = state.filters.find(({ name }) => name === 'search') || ({} as Filter);
  const [value, setValue] = useState('');

  // @see https://blog.logrocket.com/how-and-when-to-debounce-or-throttle-in-react/
  const updateFilter = useCallback(
    debounce((value: string) => setFilter({ name: 'search', value }), 300),
    // Note: We need to pass in the filters as a dependency, so that the function version will be updated.
    [state.filters]
  );

  const updateValue = (newValue: string) => {
    setValue(newValue);
    updateFilter(newValue);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    updateValue(event.target.value);

  const handleClearClick = () => updateValue('');

  useEffect(() => {
    // Note: This assists with clearing the input value when the filters are cleared.
    setValue(searchFilter.value);
  }, [state.filters]);

  return (
    <InputText
      className="filters__search__input"
      prefix={<Icon name="search" className="text-black" />}
      suffix={value ? <IconButton icon="close" onClick={handleClearClick} /> : null}
      name="searchFilter"
      placeholder="By Dish Name, Ingredient, or Category"
      onChange={handleSearchChange}
      value={value}
      data-cy="filters-search-input"
      autoComplete="off"
    />
  );
};
